import React from 'react';
import {
  Restricted,
  translate as t,
} from 'admin-on-rest';
import {
  Card,
  RaisedButton,
  List,
  ListItem,
} from 'material-ui';
import { callApi } from '../../client/apiToolbox';
import nki from './nkiV3.json';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

class RatingsBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // inputs: [],
    };
  }

  handleGetRatings = () => callApi(`${API_BASE_URL}/ext/export/ratings?lang=sv`, 'GET',
    { 'Content-Type': 'application/json', credentials: 'include' })
    .then((res) => this.setState({ json: res.json }));
  ;
  handleClick = () => callApi(`${API_BASE_URL}/ratings`, 'POST', { 'Content-Type': 'application/json', credentials: 'include' }, nki);

  render() {
    return (
      <Card>
        <div>
          <RaisedButton primary label="Add Rating" labelColor="white" onClick={this.handleClick} />
          <RaisedButton primary label="Get Rating" labelColor="white" onClick={this.handleGetRatings} />
          <List>
            <ListItem
              primaryText="Json"
              primaryTogglesNestedList
              nestedItems={[
                <pre>
                  {JSON.stringify(nki, null, 2)}
                </pre>,
              ]}
            />
          </List>

          <List>
            <ListItem
              primaryText="From callApi:"
              primaryTogglesNestedList
              nestedItems={[
                <pre>
                  { this.state.json && JSON.stringify(this.state.json, null, 2) }
                </pre>,
              ]}
            />
          </List>

        </div>
      </Card>
    );
  }
}

const Ratings = t((props) => (
  <Restricted authParams={{ route: '/nki' }} location={props.location}>
    <RatingsBuilder {...props} />
  </Restricted>
));

export default Ratings;
